
export default function getConfig() {
  let defaultConfig: AppConfig = {
    mode: "simple",
    interestRate: 5.5,
    maxLoanTerm: 36,
    programs: [
      {
        name: "Esthetic Licensure Course",
        school_period: 5,
        cost: 12200,
        pay_interest_during_school_year: false,
      },
      {
        name: "Advanced Esthetics Academy",
        school_period: 3,
        cost: 10700,
        pay_interest_during_school_year: false,
      },
      {
        name: "Clinical Medical Assistant",
        school_period: 5,
        cost: 9050,
        pay_interest_during_school_year: false,
      },
      {
        name: "Nail Technology",
        school_period: 3,
        cost: 4530,
        pay_interest_during_school_year: false,
      },
      {
        name: "Massage Therapy",
        school_period: 5,
        cost: 11130,
        pay_interest_during_school_year: false,
      },
      {
        name: "Cosmetology Program",
        school_period: 12,
        cost: 24540,
        pay_interest_during_school_year: false,
      },
    ]
  };

  if ((window as any)._seei_financial_calculator_conf) return (window as any)._seei_financial_calculator_conf as AppConfig;
  return defaultConfig;
}